import * as XLSX from "xlsx";
import dayjs from "dayjs";

/**
 * Format a number as money (LKR, 2 decimals, thousands separators).
 * @param {number|string} value
 */
export const fmtMoney = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Format a number as a plain quantity (up to 2 decimals, no trailing zeros).
 * @param {number|string} value
 */
export const fmtQty = (value) => {
  const n = Number(value || 0);
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};

/**
 * Shared Excel export for report pages.
 * Builds a worksheet from column defs + row objects and downloads it.
 *
 * @param {Object} options
 * @param {string} options.filename   - Downloaded file name (without extension)
 * @param {string} options.sheetName  - Worksheet name
 * @param {Array}  options.columns    - [{ title, dataIndex, width? }]
 * @param {Array}  options.rows       - Row objects (dataIndex -> cell value)
 * @param {Array}  [options.extraRows]- Extra raw rows appended at the end (e.g. totals)
 * @returns {boolean} true when exported
 */
export const exportRowsToExcel = ({ filename, sheetName, columns, rows, extraRows = [] }) => {
  const aoa = [columns.map((c) => c.title)];
  rows.forEach((r) => {
    aoa.push(
      columns.map((c) => {
        const v = r[c.dataIndex];
        return v === null || v === undefined ? "" : v;
      })
    );
  });
  extraRows.forEach((er) => aoa.push(er));

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = columns.map((c) => ({ wch: c.width || 20 }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || "Report");
  XLSX.writeFile(wb, `${filename}-${dayjs().format("YYYYMMDD-HHmm")}.xlsx`);
  return true;
};

const reportExport = { fmtMoney, fmtQty, exportRowsToExcel };

export default reportExport;
